(function () {
  let cookieBlock = document.getElementById("cookieBlock");
  let showCookieBtn = document.getElementById("showCookieBtn");
  let CookiesBtn = document.getElementById("CookiesBtn");
  const eBook = document.getElementById('eBook');

  if (!eBook) {
  cookieBlock.classList.add("hidden");
  if (showCookieBtn) {
    showCookieBtn.onclick = (e) => {
      e.preventDefault();
      cookieBlock.classList.add("hidden");
      document.cookie = "synechron_visitor=visitor";
    };
  }
  if (CookiesBtn) {
    CookiesBtn.onclick = (e) => {
      e.preventDefault();
      document.cookie = "synechron_visitor=visitor";
      cookieBlock.classList.add("hidden");
    };
  }

  let allCookies = document.cookie;
  if (allCookies.includes("synechron_visitor") == true) {
    cookieBlock.classList.add("hidden");
  } else {
    cookieBlock.classList.remove("hidden");
  }
};
})();
